import { useAppSelector } from 'store';
import { authStateSelector } from 'store/selectors/auth-selectors';
import { isKioskLockedSelector } from 'store/selectors/kiosk-session-selectors';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { APPLICATION_FORM_ROUTE } from 'constants/routes';
import { PublicApplicationPage } from 'modules/job-application';
import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';
import KioskRouter from './KioskRouter';

const Router = (): JSX.Element => {
  const authStatus = useAppSelector(authStateSelector);
  const isKioskLocked = useAppSelector(isKioskLockedSelector);

  // The kiosk gate sits above the auth check: activation drops the manager token, so without this
  // the app would fall through to the login screen instead of the locked kiosk shell.
  if (isKioskLocked) {
    return (
      <BrowserRouter>
        <KioskRouter />
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Above the auth branch: the applicant has no account, and a logged-in manager opening the
            link should still get the bare public form rather than the app shell. */}
        <Route path={APPLICATION_FORM_ROUTE} element={<PublicApplicationPage />} />
        <Route path="*" element={authStatus ? <AppRouter /> : <AuthRouter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
